var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.condition)?_c('div',{staticClass:"loader",class:{'mobileStyle': _vm.mobileMode}},[_c('md-spinner',{staticClass:"progressSpinner",attrs:{"md-size":300,"md-stroke":1,"md-indeterminate":""}}),_vm._v(" "),_c('span',{staticClass:"loaderContent"},[_vm._v("Loading Content")])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7259d3e2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/util/PageLoader.vue
// module id = 367
// module chunks = 0